import * as React from "react";
import SelectBillingAddressModalForm from "../../Forms/buypermits/SelectBillingAddressModalForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const SelectBillingAddressModal=(props)=>{ 
   const {isOpenSelectBillingAddressModal,CloseSelectBillingAddressModal,handleOpenAddBillingAddressModal} = props;

//    useEffect(() => {
//     const ActiveData = emailData && emailData.filter((items) => {
//       return items.inactive === false
//     })
//     setMyEmailData(ActiveData)
//     dispatch(getCheckoutSelectBillingAddressStates({accountId:1337}));
//   }, [emailData])

   
    return(
        <>
            <BaseModal
                title="Select Billing Address"
                align="center"
                open={isOpenSelectBillingAddressModal}
                onClose={CloseSelectBillingAddressModal}
                with={500}                
            >
                <BaseModalContent>
                   <SelectBillingAddressModalForm 
                      CloseSelectBillingAddressModal={CloseSelectBillingAddressModal}
                      handleOpenAddBillingAddressModal={handleOpenAddBillingAddressModal}
                   />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default SelectBillingAddressModal;